import { Button, Col, Typography } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { combo2x1ProductsService } from "../../../shared/services";
import { Iproducts2x1 } from "../../../redux/@types";
import { useProducts } from "../../products";
import { useUpdateStatusProduct2x1 } from "../hooks/useUpdateStatusProduct2x1";
import { useParams } from "react-router-dom";

const { Title } = Typography;

interface Props {
  fetchQuery?: any
}

export const TableProduct2x1 = ({fetchQuery}:Props) => {
  const { setTableProps} = useProducts();
  const { rule_id} = useParams();
  const { updateStatus } = useUpdateStatusProduct2x1();

  const columns: TableColumns<Iproducts2x1> = [
    {
      title: "ID",
      width: 1,
      dataIndex: "id",
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Producto",
      width: 5,
      dataIndex: ['product', 'name'],
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Estado",
      width: 10,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              onClick={()=>{updateStatus(item.status === 'active' ? "inactive" : 'active', item.id)}}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<Iproducts2x1>
      columns={columns}
      scroll={{}}
      fetchQueryProps={{
        rules_2_x_1_id: rule_id,
        $sort: { id: -1 },
        ...(fetchQuery),
      }}
      service={combo2x1ProductsService}
      onLoad={setTableProps}
    />
  );
};
